import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  return _openBlock(), _createBlock(_component_a_select, {
    "field-names": {
      label: 'title',
      value: 'value'
    },
    value: $props.value,
    onSelect: $setup.handleSelect,
    onDropdownVisibleChange: $setup.handleOpenDropdown,
    "not-found-content": "暂无数据"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, option => {
      return _openBlock(), _createBlock(_component_a_select_option, {
        key: option.value,
        title: `${option.value}-${option.title}`
      }, null, 8, ["title"]);
    }), 128))]),
    _: 1
  }, 8, ["value", "onSelect", "onDropdownVisibleChange"]);
}